import { useCallback, useEffect, useState } from 'react';

import {
  useGetFilterParams, UseNumberFormat,
  useSetFilterParams,
} from 'src/hooks';

export const useScaleState = (
  fieldKeyName: string,
  placeholder: string,
) => {
  const { filterParams } = useGetFilterParams();
  const { handleWriteToRedux } = useSetFilterParams();
  const { numberSeparator } = UseNumberFormat();
  const [formatScalePlaceholder, setScalePlaceholder] = useState('');
  const [formatScaleData, setFormatScaleData] = useState('');

  const handleSetScalePlaceholder = useCallback((range: string, isDelete?: boolean) => {
    if (isDelete) {
      setScalePlaceholder(`${range}`);
      setFormatScaleData('');
      handleWriteToRedux(fieldKeyName, []);
    } else {
      const splitRange = range.split(' - ');
      const formated = splitRange.map((item) => numberSeparator(item, fieldKeyName)).join(' - ');
      setScalePlaceholder(`${placeholder} ${formated}`);
      setFormatScaleData(range);

      handleWriteToRedux(fieldKeyName, splitRange);
    }
  }, [fieldKeyName, placeholder, handleWriteToRedux, numberSeparator, setFormatScaleData]);

  const handleOnClearCheckBox = useCallback(() => {
    handleWriteToRedux(fieldKeyName, []);
  }, [fieldKeyName, handleWriteToRedux]);

  const setInitValue = useCallback((value: string[] | undefined) => {
    if (value?.length) {
      handleWriteToRedux(fieldKeyName, value || []);
    }
  }, [filterParams, fieldKeyName, handleWriteToRedux]);

  useEffect(() => {
    if (filterParams[fieldKeyName]) {
      if (filterParams[fieldKeyName].data.length === 0) {
        setScalePlaceholder('');
        setFormatScaleData('');
      } else {
        const splitRange: string[] = filterParams[fieldKeyName]
          .data
          .sort((a: any, b: any) => a - b);
        const formated = splitRange.map((item) => numberSeparator(item, fieldKeyName)).join(' - ');
        setScalePlaceholder(`${placeholder} ${formated}`);
        setFormatScaleData(`${splitRange.join(' - ')}`);
      }
    }
  }, [fieldKeyName, placeholder, filterParams]);

  return {
    handleOnClearCheckBox,
    formatScalePlaceholder,
    formatScaleData,
    handleSetScalePlaceholder,
    setInitValue,
  };
};
